import React from "react";

/**
 * WebtopLayoutContext — provides the user's layout + persistence helpers to the
 * desktop, taskbar, and personalize panel. WebtopPreview calls
 * useDesktopLayoutSync ONCE and supplies the value here (so the layout loads
 * once, not per-consumer). Default is a safe no-op for isolated unit tests.
 */
const WebtopLayoutContext = React.createContext({
  layout: {},
  loaded: false,
  updateLayout: () => {},
  replaceLayout: () => {},
});

export default WebtopLayoutContext;
